import clsx from 'clsx';
import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';

/**
 * Use to truncate text in 1 lines.
 * @param root0 - Properties.
 * @param root0.text - Text to be truncated.
 * @param root0.hideOverflow - Should hide overflow.
 * @param root0.className - Class name for the component.
 * @returns - Truncated text component.
 */
export default function TruncatedText({
  text,
  hideOverflow = false,
  className
}: {
  text: ReactNode;
  hideOverflow?: boolean;
  className?: string;
}): ReactElement {
  const ref = useRef<HTMLDivElement>(null);
  const [title, setTitle] = useState('');
  useEffect(() => {
    if (ref.current) {
      setTitle(ref.current.innerText);
    }
  }, []);
  return (
    <div
      ref={ref}
      title={title}
      className={clsx(
        'truncate whitespace-nowrap text-ellipsis',
        {
          'overflow-hidden': hideOverflow
        },
        className
      )}
    >
      {text}
    </div>
  );
}
